import request from 'config/axios'

const API_OCCUPATIONS = '/resources/v3/occupations'

const getOccupations = () => request.get(API_OCCUPATIONS)

export default getOccupations

